import { useLocalizedText } from '../localizedText';

export function usePreferencesStrings(
  preferencesPrefix: string,
  pageSizes: number[],
  namespaces: string[] = ['translation']
) {
  const { t } = useLocalizedText(namespaces);

  return {
    title: t([`${preferencesPrefix}.title`, `preferences.title`]),
    confirmLabel: t([`${preferencesPrefix}.confirmLabel`, `preferences.confirmLabel`]),
    cancelLabel: t([`${preferencesPrefix}.cancelLabel`, `preferences.cancelLabel`]),
    pageSizePreference: {
      title: t([`${preferencesPrefix}.pageSizeTitle`, `preferences.pageSizeTitle`]),
      options: pageSizes.map((size) => ({
        value: size,
        label: t([`${preferencesPrefix}.pageSize`, `preferences.pageSize`], { count: size }),
      })),
    },
  };
}
